const getUsersType = 'GET_USERS';
const postUserType = 'POST_USER';
const getUserType = 'GET_USER';
const putUserType = 'PUT_USER';
const deleteUserType = 'DELETE_USER';

const initialState = { users: [] };

export const usersActions = {

    getUsers: () => async (dispatch, getState) => {
        const response = await fetch('api/users');
        const users = await response.json();
        dispatch({ type: getUsersType, users });
    },

    postUser: user => async (dispatch, getState) => {
        const response = await fetch(`api/users`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(user)
        })
        user = await response.json();
        //console.log(user);
    },

    getUser: userId => async (dispatch, getState) => {
        const response = await fetch(`api/users/${userId}`);
        const user = await response.json();
        console.log(user);
    },

    putUser: (userId, user) => async (dispatch, getState) => {
        await fetch(`api/users/${userId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(user)
        })
    },

    deleteUser: userId => async (dispatch, getState) => {
        const response = await fetch(`api/users/${userId}`, {
            method: 'DELETE',
        })
        userId = await response.json();
        dispatch({ type: deleteUserType, userId });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getUsersType:
            return { ...state, users: action.users };

        case postUserType:
            return { ...state };

        case getUserType:
            return { ...state };

        case putUserType:
            return { ...state };

        case deleteUserType:
            return { ...state, users: state.users.filter(user => user.userId !== action.userId) };

        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/store/users.js